var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"label":_vm.label,"multiple":_vm.multiple,"clearable":_vm.clearable && !_vm.selectedOnlyAny},on:{"input":_vm.onInput},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }